import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import { PassChangeApiResponse, PassChangeParams, PassChangeState } from "./PassChangeType";
import { RootState } from "../../redux/store";

//ログイン時の非同期API連携
export const fetchAsyncPassChange: any = createAsyncThunk<
  PassChangeApiResponse,
  PassChangeParams
>("pass_change/post", async ({ user_id, password, word }) => {
  const res = await axiosSettings.post("auth/pass_change.php", {
    user_id,
    password,
    word,
  });
  return res.data;
});

//初期state
const initialState: PassChangeState = {
  passChangeSuccess: false,
  msg: "",
};

//slice
export const passChangeSlice = createSlice({
  name: "passChange",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncPassChange.fulfilled, (state, action) => {
      //成功
      if (action.payload.msg === "Success") {
        state.passChangeSuccess = true;
        state.msg = "";
      }
      //失敗
      else {
        state.msg = action.payload.info;
      }
    });
  },
});


export const errorMsg = (state: RootState) => state.passChange.msg;
export const passChangeJudge = (state: RootState) => state.passChange.passChangeSuccess;
export default passChangeSlice.reducer;

